/**
 * Listed some of the ID's, which is configured in DB.
 */

export default {
  // vas type id
  VAS_TYPE_CARWASH: '24',
  VAS_TYPE_RESERVED_PARKING: '91',
  VAS_TYPE_REGULAR_PARKING: '90',
  VAS_TYPE_VALET_MANAGEMENT: '28',
  VAS_TYPE_TAXI: '7',
  VAS_TYPE_SHUTTLE: '3',
  VAS_TYPE_TROLLEY: '2',
  VAS_TYPE_QUICK_SERVICE: '144',
  VAS_TYPE_PARKING_LOCK: '5',
  VAS_TYPE_RENT_CAR: '7',
};
